import {Nullish} from 'shared/web';

type Props<T> = {
  defaultValue: T;
  setFilterValue: (value: T) => void;
};
export const useFilterOnChipsChange = <T,>(props: Props<T>) => {
  const onChipsChange = (values: string[] | Nullish) => {
    if (values && values.length > 0) {
      props.setFilterValue(values[0] as T);
    } else {
      props.setFilterValue(props.defaultValue);
    }
  };

  return {onChipsChange};
};
